import Vue from 'vue';
import CONSTANTS from './constants';
import { StateType } from './types';

export default {
  [CONSTANTS.SET_GOOGLE_VIDEO_ERROR](state: StateType, error): void {
    Vue.set(state, 'error', error);
  },
};
